import { Add } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import usePagebuilder from '../../../hooks/pagebuilder/usePagebuilder';
import { AgendaComponentInterface, AgendaEntry } from '../../../interfaces/pagebuilder';
import { addAgendaEntry } from '../../../services/services';
import VyPrivilegeWrapper from '../../common/VyPrivilegeWrapper';
import VyTooltip from '../../common/VyTooltip';
import { AgendaEditForm } from './Settings/agenda/AgendaEditForm';

interface UiTemplateAgendaControlProps {
  component: AgendaComponentInterface;
}
const UiTemplateAgendaControl = ({ component }: UiTemplateAgendaControlProps) => {
  const [isCreateModal, setIsCreateModal] = useState(false);

  const { t } = useTranslation();
  const { editComponent } = usePagebuilder(true);

  async function createEntry(props: AgendaEntry) {
    if (!component) return;
    const newComp = { ...component };
    const newEntry = await addAgendaEntry(props, component._id);
    newComp.entryList = [...(newComp.entryList || []), newEntry];
    editComponent({ ...component, entryList: newComp.entryList });
    setIsCreateModal(false);
  }

  return (
    <>
      <VyPrivilegeWrapper privilege="pagebuilder">
        {(access) => (
          <VyTooltip title={access ? t('pagebuilder:entry-add') : ''}>
            <Button
              disabled={!access}
              onClick={() => setIsCreateModal(true)}
              size="small"
              variant="contained"
              sx={{ background: 'transparent', ':hover': { backgroundColor: 'transparent' }, padding: 0 }}
              disableElevation>
              <Add fontSize="small" />
            </Button>
          </VyTooltip>
        )}
      </VyPrivilegeWrapper>
      {isCreateModal && <AgendaEditForm isModal isModalOpen onSubmit={createEntry} onCloseModal={() => setIsCreateModal(false)} />}
    </>
  );
};

export default UiTemplateAgendaControl;
